import React from 'react';
import { get, post, put, del } from '../../Utility/Http';
import { getUserApiGet} from './UserModel';
import Config from '../../Utility/Config';

export const getUserListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/sponser/list`, null);
    return getUserApiGet(response);
};


